import { Component, Input, OnInit, ChangeDetectorRef, inject, SimpleChanges, OnChanges, ViewChild, TemplateRef, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SanitizerPipe } from '../pipe/santizer.pipe';
import { GlobalService } from '../../services/global.service';
import { DynamicDialog } from '../../models/global.model';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule, MatIconModule, MatTooltipModule, SanitizerPipe],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss'
})
export class Sidebar implements OnInit, OnChanges {
  @Input() userMenus: any[] = [];

  public isSidebarCollapsed = false;
  selectedParentMenu: any;
  selectedChildMenu: any;



  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  public globalService = inject(GlobalService);
  public layout = inject(LayoutService);

  // Tablets get the icon rail by default; the drawer (mobile) always renders
  // the full menu, so "collapsed" is only meaningful on tablet/desktop.
  private collapseOnTablet = effect(() => {
    if (this.layout.isTablet()) {
      this.isSidebarCollapsed = true;
    } else if (this.layout.isDesktop()) {
      this.isSidebarCollapsed = false;
    }
  });

  get collapsed(): boolean {
    return this.isSidebarCollapsed && !this.layout.isMobile();
  }

  private relatedRoutes: { [key: string]: string[] } = {
    '/tournament': [
      '/tournament-information',
      '/tournament-add-form',
      '/tournament-edit-form',
      '/tournament-category',
      '/tournament-apply-student',
      '/tournament-manage-access',
    ]
  };

  ngOnInit() {
    this.updateOpenStatesFromActiveLinks();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateOpenStatesFromActiveLinks();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['userMenus'] && this.userMenus) {
      this.updateOpenStatesFromActiveLinks();
    }
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  isRouteActive(route: string): boolean {
    if (!route) return false;
    const normalize = (path: string) => path.startsWith('/') ? path : '/' + path;

    const currentUrl = normalize(this.router.url.split('?')[0]);
    const target = normalize(route);

    if (currentUrl === target || currentUrl.startsWith(target + '/')) {
      return true;
    }

    if (this.relatedRoutes[target]) {
      return this.relatedRoutes[target].some(related =>
        currentUrl === related || currentUrl.startsWith(related + '/')
      );
    }

    return false;
  }

  toggleMenu(menu: any, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (menu.children && menu.children.length > 0) {
      if (this.collapsed) {
        this.isSidebarCollapsed = false;
        menu.IsOpen = true;
      } else {
        menu.IsOpen = !menu.IsOpen;
      }
      if (menu.IsOpen) {
        sessionStorage.setItem('active_menu_id', menu.MenuID);
        if (menu.children.length > 0) {
          const defaultChild = menu.children[0];
          if (defaultChild.RouterPath) {
            this.router.navigate([defaultChild.RouterPath]);
          }
        }
      } else {
        sessionStorage.removeItem('active_menu_id');
      }

      this.userMenus.forEach(m => {
        if (m.MenuID !== menu.MenuID) {
          m.IsOpen = false;
        }
      });
    } else if (menu.RouterPath) {
      sessionStorage.removeItem('active_menu_id');
      this.userMenus.forEach(m => {
        m.IsOpen = false;
      });

      this.router.navigate([menu.RouterPath]);

      if (menu.ParentMenuID === '0' || !menu.ParentMenuID) {
        this.selectedParentMenu = menu.MenuID;
      } else {
        this.selectedParentMenu = menu.ParentMenuID;
        this.selectedChildMenu = menu.MenuID;
      }
    }

    this.cdr.detectChanges();
  }

  onMenuClick(menu: any, event: Event) {
    this.toggleMenu(menu, event);
  }

  updateOpenStatesFromActiveLinks() {
    this.userMenus.forEach((menu) => {
      if (menu.children && menu.children.length > 0) {
        const hasActiveChild = menu.children.some((child: any) =>
          this.isRouteActive(child.RouterPath)
        );
        if (hasActiveChild) {
          menu.IsOpen = true;
          sessionStorage.setItem('active_menu_id', menu.MenuID);
        }
      }
    });
  }
}
